import { GzMaintenanceWindowSummariesWebComponent } from './component/GzMaintenanceWindowSummariesWebComponent';

export { GzMaintenanceWindowSummariesWebComponent };
